module.exports = __webpack_public_path__ + "img/a422237.jpg";